module.exports = __webpack_public_path__ + "static/media/external_1.a31aa1ab.jpg";